import { useRef, useEffect } from 'react';
import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
import styles from './style.module.scss';
import img1 from '../img/1.jpg';
import img2 from '../img/kamla.jpg';
import img3 from '../img/ghostoftsushima.jpg';
import img4 from '../img/Destiny2.jpeg';
import img5 from '../img/float1.jpg';
import img6 from '../img/float2.jpg';
import img7 from '../img/float3.jpg';
import img8 from '../img/float4.jpg';

gsap.registerPlugin(ScrollTrigger);

const slider1 = [
    { color: "#3e3c3c", src: img1 },
    { color: "#d6d7dc", src: img2 },
    { color: "#3e3c3c", src: img3 },
    { color: "#d6d7dc", src: img4 },
];

const slider2 = [
    { color: "#3e3c3c", src: img5 },
    { color: "#d6d7dc", src: img6 },
    { color: "#3e3c3c", src: img7 },
    { color: "#d6d7dc", src: img8},

];

export default function SlidingImages() {
    const containerRef = useRef(null);
    const slider1Ref = useRef(null);
    const slider2Ref = useRef(null);
    // const circleContainerRef = useRef(null);
    const circleRef = useRef(null);

    useEffect(() => {
        const container = containerRef.current;
        const slider1 = slider1Ref.current;
        const slider2 = slider2Ref.current;
        // const circleContainer = circleContainerRef.current;
        const circle = circleRef.current;

        gsap.to(slider1, {
            x: 200,
            ease: "power1.out",
            scrollTrigger: {
                trigger: container,
                start: "top bottom",
                end: "bottom top",
                scrub: 0.8
            }
        });

        gsap.to(slider2, {
            x: -100,
            ease: "power1.out",
            scrollTrigger: {
                trigger: container,
                start: "top bottom",
                end: "bottom top",
                scrub: 0.7
            }
        });

        
        gsap.to(circle, {
            borderBottomLeftRadius: "0%",
            borderBottomRightRadius: "0%",
            height: -280,
            duration: 2,
            ease: "power1.out",
            scrollTrigger: {
                trigger: circle,
                start: "top 80%",
                end: "bottom top",
                scrub: 1  // Adjust scrubbing speed as needed
            }
        });
    }, []);

    return (
        <div ref={containerRef} className={styles.slidingImages}>
            <div ref={slider1Ref} className={styles.slider}>
                {slider1.map((project, index) => (
                    <div key={index} className={styles.project} style={{ backgroundColor: project.color }}>
                        <div className={styles.imageContainer}>
                            <img alt="image" src={project.src} />
                        </div>
                    </div>
                ))}
            </div>
            <div ref={slider2Ref} className={styles.slider}>
                {slider2.map((project, index) => (
                    <div key={index} className={styles.project} style={{ backgroundColor: project.color }}>
                        <div className={styles.imageContainer}>
                            <img alt="image" src={project.src} />
                        </div>
                    </div>
                ))}
            </div>
            <div className={styles.circleContainer}>
                <div ref={circleRef} className={styles.circle}></div>
            </div>
        </div>
    );
}
